export function getUserToken() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) return user;
  return null;
}